module.exports = __webpack_public_path__ + "static/img/ad20-1.24d8709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad20-1.png
// module id = 58bP
// module chunks = 12